import React from 'react';

import { OrganizationCard as OrganizationCardType } from '../../types';

import * as S from './styles';

type Props = {
  organization: OrganizationCardType;
  onOpenLetter: () => void;
};

function FeaturedOrganizationCard(props: Props) {
  const { organization, onOpenLetter } = props;
  const { name, logoUrl, authorName, authorTitle, welcomeMessage, isFeatured } =
    organization;

  const subtitle = `A note from ${authorName}, ${authorTitle}`;
  const ctaText = `Open ${authorName}'s letter`;

  return (
    <S.CardContainer>
      <S.LogoSection>
        <S.LogoWrapper>
          <S.OrganizationLogo alt={`${name} logo`} src={logoUrl} />
        </S.LogoWrapper>
      </S.LogoSection>

      <S.ContentSection>
        {isFeatured && <S.FeaturedBadge>Featured Partner</S.FeaturedBadge>}
        <S.OrganizationName>
          <span>{name}</span>
          <S.Subtitle>{subtitle}</S.Subtitle>
        </S.OrganizationName>
        <S.BodyText>{welcomeMessage}</S.BodyText>
        <S.CTALink onClick={onOpenLetter}>{ctaText} →</S.CTALink>
      </S.ContentSection>
    </S.CardContainer>
  );
}

export default FeaturedOrganizationCard;
